import { render, staticRenderFns } from "./ReceptionDepartmentFixedPhraseSelector.vue?vue&type=template&id=a20e257e&scoped=true&"
import script from "./ReceptionDepartmentFixedPhraseSelector.vue?vue&type=script&lang=ts&"
export * from "./ReceptionDepartmentFixedPhraseSelector.vue?vue&type=script&lang=ts&"
import style0 from "./ReceptionDepartmentFixedPhraseSelector.vue?vue&type=style&index=0&id=a20e257e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a20e257e",
  null
  
)

export default component.exports